import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../firebase/firebase';
import signInRequest from './doRequest';


const handleGoogleSignIn = async () => {
    try {
        const result = await signInWithPopup(auth, provider);
        console.log('✅ User signed in:', result.user.displayName);

        // Prepare the data to send
        const userData = result.user;

        const currentDbUSer = await signInRequest(userData)
        console.log('CurrentDbUser[signin]', currentDbUSer)
        

        console.log('Result?', result);
        return true
    } catch (error) {
        console.error('❌ Sign-in or fetch error:', error);
        return false
    }
};

export default handleGoogleSignIn; // Exported as default after declaration